webpackJsonp([113770797597502],{

/***/ 1675:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"BolusCalculationResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":"Volume per kg (ml/kg)","isDeprecated":false,"name":"amount","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":"Patient weight in kg used for calculation","isDeprecated":false,"name":"patientWeightKg","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":"Bolus rate (ml/hr)","isDeprecated":false,"name":"rate","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":"Total volume (ml)","isDeprecated":false,"name":"totalAmount","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":"Result of bolus calculation","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-bolus-calculation-result-f4101ab76cb9ad94205f.js